/**
 * CloudFront utility functions
 * Exposes functions to the global window object for use in inline scripts
 */

/**
 * Get CloudFront Key Pair ID from meta tag
 * @returns {string|null} The CloudFront Key Pair ID or null if not found
 */
export function getCloudFrontKeyPairId() {
  const meta = document.querySelector('meta[name="cloudfront-key-pair-id"]');
  return meta ? meta.getAttribute('content') : null;
}

// Expose to window for inline scripts
if (typeof window !== 'undefined') {
  window.getCloudFrontKeyPairId = getCloudFrontKeyPairId;
}
